export const regularServicedSitePictures = [
  {
    display_name: `Site 76`,
    location: require("./regular_serviced_site_pictures/regular_76.jpg"),
  },
  {
    display_name: `Site 69`,
    location: require("./regular_serviced_site_pictures/regular_69.webp"),
  },
  {
    display_name: `Site 70`,
    location: require("./regular_serviced_site_pictures/regular_70.webp"),
  },

  {
    display_name: `Site 41`,
    location: require("./regular_serviced_site_pictures/regular_41.webp"),
  },
  {
    display_name: `Site Q (pull-through)`,
    location: require("./regular_serviced_site_pictures/regular_q.jpg"),
  },
  {
    display_name: `Site 72 (pull-through)`,
    location: require("./regular_serviced_site_pictures/regular_72.jpg"),
  },
  {
    display_name: `Site 50`,
    location: require("./regular_serviced_site_pictures/regular_50.webp"),
  },
  {
    display_name: `Site 71`,
    location: require("./regular_serviced_site_pictures/regular_71.jpg"),
  },
  {
    display_name: `Site 65`,
    location: require("./regular_serviced_site_pictures/regular_65.jpg"),
  },
  {
    display_name: `Site H`,
    location: require("./regular_serviced_site_pictures/regular_h.jpg"),
  },
  {
    display_name: `Site M`,
    location: require("./regular_serviced_site_pictures/regular_m.jpg"),
  },
  {
    display_name: `Site L`,
    location: require("./regular_serviced_site_pictures/regular_l.jpg"),
  },
  {
    display_name: `Site 31`,
    location: require("./regular_serviced_site_pictures/regular_31.webp"),
  },
  {
    display_name: `Site 5`,
    location: require("./regular_serviced_site_pictures/regular_5.jpg"),
  },
  {
    display_name: `Site Y`,
    location: require("./regular_serviced_site_pictures/regular_y.webp"),
  },
  {
    display_name: `Site 6`,
    location: require("./regular_serviced_site_pictures/regular_6.webp"),
  },
  {
    display_name: `Site 7`,
    location: require("./regular_serviced_site_pictures/regular_7.jpg"),
  },
  {
    display_name: `Site 4A`,
    location: require("./regular_serviced_site_pictures/regular_4a.jpg"),
  },
];
